import currency from "currency.js";

export const volumeFormatter = (volume = 0) =>
  currency(volume, {
    separator: ",",
    precision: 0,
    symbol: "",
  }).format();
